import { PATHS } from '@/router/paths';

/** App route stack used to decide Back target without relying on browser History API alone. */
let pathStack: string[] = [PATHS.HOME.INDEX];

/**
 * Keep in sync with React Router pathname changes (push / back / replace).
 * - Back: new path matches previous entry → pop
 * - Push: new path differs from current → push
 * - Same pathname (e.g. language refresh): no-op
 */
export function syncNavigationHistory(pathname: string) {
    if (pathStack.length >= 2 && pathStack[pathStack.length - 2] === pathname) {
        pathStack.pop();
        return;
    }

    if (pathStack[pathStack.length - 1] !== pathname) {
        pathStack.push(pathname);
    }
}

export function getPreviousPathname(): string | undefined {
    return pathStack.length >= 2 ? pathStack[pathStack.length - 2] : undefined;
}

export function willBackGoToHome(): boolean {
    return getPreviousPathname() === PATHS.HOME.INDEX;
}
